/* import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client'

// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
const AUTH_TOKEN = 'apollo-token'

// Http endpoint
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:8085/query'

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:8085/query',
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  // Override default cache
  // cache: myCache

  // Override the way the Authorization header is set
  // getAuth: () => 'Bearer DEMO-ALL',

  // Additional ApolloClient options
  // apollo: { ... }
  // httpLinkOptions: {
  //   fetchOptions: {
  //     mode: 'no-cors',
  //   },
  // }
  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
}

// Call this in the Vue app file
export function createProvider (options = {}) {
  // Create apollo client
  const { apolloClient, wsClient } = createApolloClient({
    ...defaultOptions,
    ...options
  })
  apolloClient.wsClient = wsClient

  // Create vue apollo provider
  return new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      }
    },
    errorHandler (error) {
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
    }
  })
}

// Manually call this when user log in
export async function onLogin (apolloClient, token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

// Manually call this when user log out
export async function onLogout (apolloClient) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
  }
} */

/* 222222222222222222
import { ApolloClient } from 'apollo-client'
import { split, ApolloLink } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { InMemoryCache } from 'apollo-cache-inmemory'
import fetch from 'node-fetch'

const authLink = new ApolloLink((operation, forward) => {
  const token = window.localStorage.getItem('auth_token')

  operation.setContext({
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  })

  return forward(operation)
})

const httpLink = authLink.concat(new HttpLink({
  uri: `${process.env.VUE_APP_GRAPHQL_HTTP}` || 'http://localhost:8085/query',
  options: { mode: 'no-cors' }
}))

const subscriptionLink = process.browser ? new WebSocketLink({
  uri: `${process.env.VUE_APP_GRAPHQL_WS}` || 'ws://localhost:8085/query',
  options: {
    reconnect: true,
    mode: 'no-cors',
    connectionParams: () => {
      const token = window.localStorage.getItem('auth_token')
      return {
        Authorization: token ? `Bearer ${token}` : ''
      }
    }
  }
}) : null

const link = process.browser ? split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  subscriptionLink,
  httpLink
) : httpLink

const cache = new InMemoryCache()

export const apolloClient = new ApolloClient({
  link: link,
  fetch: fetch,
  cache: cache
}) */

import { ApolloClient } from 'apollo-client'
import { split, ApolloLink } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { HttpLink } from 'apollo-link-http'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { InMemoryCache } from 'apollo-cache-inmemory'
import fetch from 'node-fetch'
import { Auth } from 'aws-amplify'

const withToken = setContext(async () => {
  const session = await Auth?.currentSession()
  const token = session?.accessToken?.jwtToken
  return { token }
})

const authLink = new ApolloLink((operation, forward) => {
  const { token } = operation?.getContext() || { token: null }
  operation.setContext(() => ({
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  }))

  return forward(operation)
})

const httpLink = ApolloLink.from([withToken, authLink.concat(new HttpLink({
  uri: `${process.env.VUE_APP_GRAPHQL_HTTP}`,
  options: { mode: 'no-cors' }
}))])

const subscriptionLink = process.browser ? new WebSocketLink({
  uri: `${process.env.VUE_APP_GRAPHQL_WS}`,
  options: {
    mode: 'no-cors',
    lazy: true,
    reconnect: true,
    connectionParams: async () => {
      const session = await Auth?.currentSession()
      const token = session?.accessToken?.jwtToken
      return {
        Authorization: token ? `Bearer ${token}` : ''
      }
    }
  }
}) : null

export const subscriptionClient = subscriptionLink?.subscriptionClient || {}

const subLink = process.browser ? subscriptionLink : null

const link = process.browser ? split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  subLink,
  httpLink
) : httpLink

const cache = new InMemoryCache({ resultCaching: false })

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore'
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  }
}

export const apolloClient = new ApolloClient({
  link: link,
  fetch: fetch,
  cache: cache,
  defaultOptions
})
